var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Connection, PublicKey } from '@solana/web3.js';
import { ChainId, NATIVE_SOL } from '../../config/networks';
/**
 * Fetches the token balances for a given owner on the Solana network.
 * @param network - The network on which the tokens exist.
 * @param tokens - The array of token mint addresses.
 * @param owner - The owner's public key.
 * @returns An array of objects each containing the token address, raw balance, balance, and error message (if any).
 */
export function fetchSVMTokenBalances(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var network, connection, results, ownerPublicKey, _i, tokens_1, token, mintPublicKey, balance, decimals, tokenAccounts, tokenAccount, accountInfo, parsedInfo, rawBalance, decimals, e_1;
        var tokens = _b.tokens, owner = _b.owner;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    network = ChainId.SOLANA;
                    connection = new Connection('https://thrumming-evocative-arrow.solana-mainnet.quiknode.pro/b95508bd97189273edee98f183d296d43bd7f4f0/');
                    results = [];
                    ownerPublicKey = new PublicKey(owner);
                    _i = 0, tokens_1 = tokens;
                    _c.label = 1;
                case 1:
                    if (!(_i < tokens_1.length)) return [3 /*break*/, 11];
                    token = tokens_1[_i];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 9, , 10]);
                    mintPublicKey = new PublicKey(token);
                    if (!(token === NATIVE_SOL)) return [3 /*break*/, 4];
                    return [4 /*yield*/, connection.getBalance(ownerPublicKey)];
                case 3:
                    balance = _c.sent();
                    decimals = 9;
                    results.push({
                        network: network,
                        token: token,
                        rawBalance: BigInt(balance),
                        balance: balance / Math.pow(10, decimals),
                        error: '',
                    });
                    return [3 /*break*/, 8];
                case 4: return [4 /*yield*/, connection.getTokenAccountsByOwner(ownerPublicKey, {
                        mint: mintPublicKey,
                    })];
                case 5:
                    tokenAccounts = _c.sent();
                    if (!(tokenAccounts.value.length === 0)) return [3 /*break*/, 6];
                    results.push({
                        network: network,
                        token: token,
                        rawBalance: BigInt(0),
                        balance: 0,
                        error: 'No token account found',
                    });
                    return [3 /*break*/, 8];
                case 6:
                    tokenAccount = tokenAccounts.value[0];
                    return [4 /*yield*/, connection.getParsedAccountInfo(tokenAccount.pubkey)];
                case 7:
                    accountInfo = _c.sent();
                    if (accountInfo.value) {
                        parsedInfo = accountInfo.value.data;
                        rawBalance = BigInt(parsedInfo.parsed.info.tokenAmount.amount);
                        decimals = parsedInfo.parsed.info.tokenAmount.decimals;
                        results.push({
                            network: network,
                            token: token,
                            rawBalance: rawBalance,
                            balance: Number(rawBalance) / Math.pow(10, decimals),
                            error: '',
                        });
                    }
                    else {
                        results.push({
                            network: network,
                            token: token,
                            rawBalance: BigInt(0),
                            balance: 0,
                            error: 'Failed to parse account info',
                        });
                    }
                    _c.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_1 = _c.sent();
                    results.push({
                        network: network,
                        token: token,
                        rawBalance: BigInt(0),
                        balance: 0,
                        error: "Error fetching token balance: ".concat(e_1.message),
                    });
                    return [3 /*break*/, 10];
                case 10:
                    _i++;
                    return [3 /*break*/, 1];
                case 11: return [2 /*return*/, results];
            }
        });
    });
}
